// rrd import
import { NavLink } from "react-router-dom";
import FooterCopyright from "../components/FooterCopyright";
// Components
import Footer from "../components/Footer";
import MissionVision from "../components/MissionVision";
import Testimonials from "../components/Testimonials";
import WhySchool from "../components/WhySchool";

const Home = () => {
    return ( 
        <>
            <div className="home">
                <p className="title" style={{color: '#ab0303', fontFamily: 'Gabriola' }}>Welcome to Little Sanctum</p>
                <p className="info">Rooted in the Montessori philosophy, our preschool offers a nurturing environment where your child can grow socially, emotionally, and intellectually—at their own unique pace. We’re not just a school—we’re a supportive community that values partnership with families as we guide children on their journey of discovery, independence, and joy in learning.
We invite you to explore our programs, meet our dedicated educators, and see how Montessori can make a lasting difference in your child early years.</p>
                <NavLink to='/about'>Explore</NavLink>
            </div>
            <MissionVision />
            <WhySchool />
            <Testimonials />
            <Footer />
            <FooterCopyright />
        </>
    );
}
 
export default Home;